import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";

import App from "./App";
import store from "./store/index";

import "./index.css";
import UrlParser from "./components/UrlParser/UrlParser";

ReactDOM.render(
  <Provider store={store}>
  {/* removing url parser loads waders */}
    <UrlParser>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </UrlParser>
  </Provider>,
  document.getElementById("root")
);
